import { IconInfoCircle } from "@tabler/icons-react";
import cntl from "cntl";
import PropTypes from "prop-types";

const propTypes = {
  udm: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string,
  idIcon: PropTypes.string,
};

function MetricChart({ title, udm, value, idIcon }) {
  const wrapperCn = () => cntl`
    p-6
    border
    bg-white
    shadow-sm
    rounded-lg
    max-w-[25rem]
    border-grey-200
  `;

  const container = () => cntl`
    flex
    gap-y-6
    flex-col
  `;

  const iconCn = () => cntl`
    w-6
    h-6
    text-grey-600
    cursor-pointer
  `;

  const headerCn = () => cntl`
    flex
    flex-row
    items-center
    justify-between
  `;

  const titleCn = () => cntl`
    text-base
    font-medium
    text-grey-900
    first-letter:uppercase
  `;

  const leftContent = () => cntl`
    flex
    flex-col
  `;

  const content = () => cntl`
    flex
    flex-row
  `;

  const valueAndUdmCn = () => cntl`
    flex
    flex-row
    gap-x-1.5
    items-end
  `;

  const valueCn = () => cntl`
    text-4xl
    font-semibold
    text-grey-900
  `;

  const udmCn = () => cntl`
    font-medium
    text-grey-900
  `;

  return (
    <div className={wrapperCn()}>
      <div className={container()}>
        <div className={headerCn()}>
          {title?.length > 0 && <div className={titleCn()}>{title}</div>}
          <IconInfoCircle id={idIcon} className={iconCn()} />
        </div>
        <div className={content()}>
          <div className={leftContent()}>
            <div className={valueAndUdmCn()}>
              <div className={valueCn()}>{value}</div>
              <div className={udmCn()}>{udm}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

MetricChart.propTypes = propTypes;
export default MetricChart;
